import { useIntl } from 'react-intl'
import settings from '../settings'

const { locales } = settings

export default function useLocale() {
  const { locale } = useIntl()

  const isLocaleFa = () => {
    if (locale === locales.fa) return true
    return false
  }
  return { isFarsi: isLocaleFa() }
}
